export default "__VITE_ASSET__BHkRhx9j__"